
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/fan-badge",
      function () {
        return require("private-next-pages/profile/fan-badge/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/fan-badge"])
      });
    }
  